import { PageSection } from '@/components/common/PageSection';
import { SectionHeading } from '@/components/common/SectionHeading';
import { Clients } from '@/pages/Home/data';

const SectionId = 'clients';
const TitleId = 'clients-title';

export function ClientsSection() {
  return (
    <PageSection id={SectionId} titleId={TitleId}>
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <SectionHeading id={TitleId} title={Clients.title} description={Clients.description} />
        </div>
        <ul className="grid gap-8 sm:grid-cols-2 lg:col-span-7">
          {Clients.items.map((client) => (
            <li key={client.title} className="border-l-2 border-grid pl-5">
              <h3 className="text-lg font-bold text-graphite">{client.title}</h3>
              <p className="mt-2 leading-relaxed text-steel">{client.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </PageSection>
  );
}